import { render, staticRenderFns } from "./total_earned_card.vue?vue&type=template&id=0e2d1f04&"
import script from "./total_earned_card.vue?vue&type=script&lang=js&"
export * from "./total_earned_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports